import { reactive } from 'vue';
import {
	PROMO_CATEGORY,
	NEAR_CATEGORY,
	POPULAR_CATEGORY,
	RECENT_CATEGORY,
	BAHANDI_CATEGORY,
	SF_CATEGORY,
	SATPAI_BURGER_CATEGORY,
	SATPAI_DONER_CATEGORY
} from './constants';
import { PaginationWrapperModel } from '@/utils/models';
import { VISIBLE_TOWNS } from '@/utils/constants';
import type {
	IFilial,
	IFilialExtended,
	ICategoryWithFilials
} from '@/types/interfaces/navigator';
import type { Town } from '@/types/interfaces/config';

interface IState {
	promoFilialsCategory: ICategoryWithFilials<IFilial>;
	nearFilialsCategory: ICategoryWithFilials<IFilial>;
	popularFilialsCategory: ICategoryWithFilials<IFilial>;
	recentFilialsCategory: ICategoryWithFilials<IFilial>;
	bahandiFilialsCategory: ICategoryWithFilials<IFilial>;
	sfFilialsCategory: ICategoryWithFilials<IFilial>;
	satpaiBurgerFilialsCategory: ICategoryWithFilials<IFilial>;
	satpaiDonerFilialsCategory: ICategoryWithFilials<IFilial>;
	recentFilial: IFilialExtended | null;
	hasError: boolean;
	towns: Town[];
}

const state = reactive<IState>({
	promoFilialsCategory: {
		...PROMO_CATEGORY,
		filials: new PaginationWrapperModel()
	},
	nearFilialsCategory: {
		...NEAR_CATEGORY,
		filials: new PaginationWrapperModel()
	},
	popularFilialsCategory: {
		...POPULAR_CATEGORY,
		filials: new PaginationWrapperModel()
	},
	recentFilialsCategory: {
		...RECENT_CATEGORY,
		filials: new PaginationWrapperModel()
	},
	bahandiFilialsCategory: {
		...BAHANDI_CATEGORY,
		filials: new PaginationWrapperModel()
	},
	sfFilialsCategory: {
		...SF_CATEGORY,
		filials: new PaginationWrapperModel()
	},
	satpaiBurgerFilialsCategory: {
		...SATPAI_BURGER_CATEGORY,
		filials: new PaginationWrapperModel()
	},
	satpaiDonerFilialsCategory: {
		...SATPAI_DONER_CATEGORY,
		filials: new PaginationWrapperModel()
	},
	recentFilial: null,
	hasError: false,
	towns: VISIBLE_TOWNS
});

export { IState, state };
